import { DefaultButton } from "@fluentui/react";
import React from "react";
import styles from "./suggestedPrompts.module.css";

type SuggestedPromptsProps = {
    onPromptSelected: (prompt: string) => void;
    prompts: string[];
    disabled: boolean;
};

export const SuggestedPrompts: React.FC<SuggestedPromptsProps> = ({ onPromptSelected, prompts, disabled }) => {
    return (
        <div className={styles.suggestedPromptContainer}>
          {prompts.map((prompt) => (
            <DefaultButton
              key={prompt}
              text={prompt}
              onClick={() => onPromptSelected(prompt)}
              disabled={disabled}
              className={styles.suggestedPrompt}
              styles={{
                root: { height: "auto", minHeight: 30,},
                label: { fontWeight: 500, fontFamily: 'HelveticaNowTELUS', lineHeight: "1.1"}
              }}
            />
          ))}
        </div>
    );
};

